import { Button, Text, csx } from '@vtex/admin-ui'
import React, { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import ClosePaymentAppIcon from './header/ClosePaymentAppIcon'

export interface PaymentAppCancelProps {
  onDismiss: () => void
  onGiveUp: () => void
}
const PaymentAppCancel = ({
  onDismiss: handleDismiss,
  onGiveUp: handleGiveUp,
}: PaymentAppCancelProps) => {
  return (
    <Fragment>
      <div
        className={csx({
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        })}
      >
        <div
          className={csx({
            padding: '12px',
            alignItems: 'center',
            width: '100%',
            display: 'flex',
            justifyContent: 'end',
          })}
        >
          <ClosePaymentAppIcon onClose={handleGiveUp} />
        </div>
        <Text
          variant="pageTitle"
          className={csx({
            textAlign: 'center',
            fontWeight: 'bold',
            marginTop: '27px',
            marginX: '40px',
          })}
        >
          <FormattedMessage id="paymentApp.modal.cancel.title" />
        </Text>
        <Text
          className={csx({
            textAlign: 'center',
            marginTop: '24px',
            marginX: '28px',
          })}
        >
          <FormattedMessage id="paymentApp.modal.cancel.description" />
        </Text>
      </div>
      <div
        className={csx({
          display: 'flex',
          flexDirection: 'column',
          padding: '16px',
          width: '100%',
        })}
      >
        <Button
          className={csx({ height: '48px', marginTop: '24px' })}
          variant="primary"
          onClick={handleDismiss}
        >
          <FormattedMessage id="paymentApp.modal.cancel.button" />
        </Button>
      </div>
    </Fragment>
  )
}

export default PaymentAppCancel
